type ErrorHandler = (message: string | null) => void;
let _handler: ErrorHandler | null = null;

export const registerErrorHandler = (fn: ErrorHandler) => {
  _handler = fn;
};

export const emitApiError = (message: string | null) => {
  _handler?.(message);
};
